import type { MeterBarChartThresholdIndicatorPropsInternal } from '../types/meter-bar-chart-internal.js';
import type { MeterBarChartThresholdIndicatorProps } from '../types/meter-bar-chart.js';

export const applyThresholdDefaults = (
  threshold: MeterBarChartThresholdIndicatorProps,
): MeterBarChartThresholdIndicatorPropsInternal => {
  return {
    value: threshold.value,
    name: threshold.name,
    color: threshold.color,
    // The deprecated per-threshold `showIndicator` is preserved as-is (an unset
    // flag stays `undefined`) so the chart-level `showThresholdIndicators`
    // fallback can distinguish "not specified" from an explicit `false`.
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    showIndicator: threshold.showIndicator,
  };
};
